<script setup>
import DeveloperCard from '@/components/partials/DeveloperCard.vue';
import { Carousel, Slide } from 'vue3-carousel';
import { ref, defineProps } from 'vue';

const carouselModel = ref(0);

const props = defineProps({
  hasPB: {
    type: Boolean,
    required: false,
    default: false,
  },
  backgroundColor: {
    type: String,
    required: false,
    default: 'var(--light-1)',
  },
});

const developers = ref([
  {
    name: 'Ujjwal Raja Maharjan',
    title: 'Senior Full Stack Engineer',
    hasImage: true,
    message: `Working at DIGU has been a truly rewarding and inspiring experience. The supportive work culture, flexibility, and balance between professional and personal growth have exceeded my expectations. DIGU promotes a collaborative environment where ideas are trusted, encouraged, and given space to grow, allowing us to take ownership with confidence. This combination of support, trust, and freedom keeps me motivated and enthusiastic about continuing my journey with DIGU.`,
  },

  {
    name: 'Rubin Maharjan',
    title: 'Senior UI/UX Designer',
    hasImage: true,
    message: `I'm truly thankful to DIGU for helping me land full-time employment with a US-based company. Their recruitment process, which was both meticulous and smooth, opened the door for me to work with a diverse and talented global pool. I am grateful to the DIGU team for their unwavering commitment to advancing careers and their efforts in connecting professionals with opportunities worldwide. My career has been significantly transformed through their impact. As I move forward in my professional journey with the skills and confidence they've helped me develop, I look forward to the exciting opportunities ahead.`,
  },

  {
    name: 'Shirish Parajuli',
    title: 'Frontend Developer',
    hasImage: true,
    message: `Being part of DIGU has been a rewarding journey for my career and personal growth. What I love most is that my ideas and words are truly valued; they’re not only heard but also supported and encouraged, which gives me the confidence to explore and grow further. The team here is so approachable and supportive, it’s easy to ask for guidance, share thoughts, and feel appreciated. The flexibility also makes a big difference, helping me balance work and life without feeling stressed. For me, DIGU isn’t just a workplace, it’s a place where I feel motivated, supported, and excited to keep learning and moving forward.`,
  },
]);
</script>
<template>
  <div class="main-container">
    <div :class="{ 'pb-5': props.hasPB }" class="stories-container">
      <h3 class="dms700 title">
        What Do Our <span class="highlight">Talents</span> Say?
      </h3>
      <section class="developer-stories">
        <v-row justify="center" class="desktop-stories">
          <v-col
            v-for="(developer, index) in developers"
            :key="index"
            cols="12"
            xs="12"
            md="4"
            class="d-flex justify-center"
          >
            <DeveloperCard
              :name="developer.name"
              :title="developer.title"
              :message="developer.message"
              :hasImage="developer.hasImage"
            ></DeveloperCard>
          </v-col>
        </v-row>
      </section>
      <div class="mobile-stories">
        <Carousel
          v-model="carouselModel"
          :wrap-around="true"
          :items-to-show="1"
        >
          <Slide
            v-for="(developer, index) in developers"
            :key="index"
            class="mobile-stories__slide"
          >
            <div class="">
              <DeveloperCard
                :name="developer.name"
                :title="developer.title"
                :message="developer.message"
                :hasImage="developer.hasImage"
              ></DeveloperCard>
            </div>
          </Slide>
        </Carousel>
        <!-- Custom slider indicators -->
        <div class="slider-indicators">
          <div
            v-for="(_, index) in developers"
            :key="index"
            class="indicator"
            :class="{
              active: index === carouselModel,
              current: index === carouselModel,
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.stories-container {
  background-color: v-bind('props.backgroundColor');
}

.title {
  background-color: v-bind('props.backgroundColor');
  padding-bottom: 2rem;
  line-height: 1.75rem;
  font-size: 1.5rem;
}
.main-container {
  background-color: v-bind('props.backgroundColor');
  padding-block: 4rem;
}
.desktop-stories {
  display: none;
  width: 95%;
  max-width: 1400px;
  margin-inline: auto;
}

.mobile-stories__slide {
  /* padding: 1rem; */
}

@media only screen and (min-width: 1280px) {
  .desktop-stories {
    display: flex;
  }

  .mobile-stories {
    display: none;
  }
}
@media only screen and (max-width: 700px) {
  .main-container {
    padding-block: 4rem;
  }
}

.highlight {
  color: var(--primary-color);
}
.slider-indicators {
  display: none;
}
.slider-indicators {
  display: flex;
  justify-content: center;
  gap: 8px;
  /* margin-top: 1.5rem;
  padding-bottom: 1rem; */
  background-color: v-bind('props.backgroundColor');
}

.indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e0e0e0;
  transition: all 0.3s ease;
}

.indicator.active {
  background: #2196f3;
}

.indicator.current {
  width: 24px;
  border-radius: 4px;
}
</style>
